
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pam/kubernetes",
      function () {
        return require("private-next-pages/pam/kubernetes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pam/kubernetes"])
      });
    }
  